<template>
  <div>
    <a @click="fnShowModal()" class="">
      <wdAvatarPreview
        :coverImgUrl="coverImgUrl"
        :fontAwClass="fontAwClass"
      ></wdAvatarPreview>
    </a>

    <b-modal ref="modal" scrollable size="xl" hide-footer>
      <div class="d-block">
        <div v-if="coverImgUrl">
          <img :src="coverImgUrl" class="img-responsive" />
        </div>
        <div v-else>
          <p>Sorry, No image to view</p>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import wdAvatarPreview from './WDAvatarPreview.vue'
export default {
  name: 'ModelImageAvatarPreview',
  props: ['coverImgUrl', 'fontAwClass'],
  components: {
    wdAvatarPreview
  },
  methods: {
    fnShowModal() {
      this.showModal()
    },
    hideModal() {
      this.$refs.modal.hide()
    },
    showModal() {
      this.$refs.modal.show()
    }
  }
}
</script>